// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"DropdownForEdit_dropdownContainer__NC1qR","dropdownMenu":"DropdownForEdit_dropdownMenu__7emus","menuItem":"DropdownForEdit_menuItem__f4Kwj"};